import React from "react";
import PostAddForm from "../../../../components/forms/postItemsForm/index";
import Loader from "../../../../components/Loader";
import { useHomeMadePostAdd } from "../../../../hooks/shop/homemadepostadd/useHomeMadePostAdd";

const HomeMadePostAddForm = () => {
  const {
    id,
    isloading,
    displayimg,
    setDisplayimg,
    isUploading,
    uploadProgress,
    shopCategory,
    shopCategorytwo,
    data,
    Handledata,
    userData,
    setUserData,
    FirstCategory,
    Mydata,
    userDatahandler,
    getRootProps,
    getInputProps,
  } = useHomeMadePostAdd();

  if (isloading) {
    return <Loader heightsetting="screenHeight" />;
  }

  return (
    <PostAddForm
      back={`/homemadeownerprofile/${id}`}
      Handledata={Handledata}
      shopCategory={shopCategory}
      Mydata={Mydata}
      data={data}
      shopCategorytwo={shopCategorytwo}
      butn="Post"
      postbtn={`/homemadeownerprofile/${id}`}
      cancel={`/homemadeownerprofile/${id}`}
      setUserData={setUserData}
      handlerFunction={userDatahandler}
      userData={userData}
      id={id}
      getInputProps={getInputProps}
      getRootProps={getRootProps}
      displayimg={displayimg}
      setDisplayimg={setDisplayimg}
      FirstCategory={FirstCategory}
      isUploading={isUploading}
      uploadProgress={uploadProgress}
    />
  );
};

export default HomeMadePostAddForm;
